export default __webpack_public_path__ + "static/3-ff83c7f867f267aee8ad4f883a978b7b.jpeg";